import { useState, useEffect } from 'react';
import { Clock, ArrowUpRight } from 'lucide-react';
import { useSubscription } from '../../contexts/SubscriptionContext';
import { useCopy } from '../../i18n';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import PricingPage from './PricingPage';

const DISMISSED_KEY = 'meugantt_trial_expired_dismissed';

export default function TrialExpiredModal() {
  const { isTrialExpired, isFree, subscription } = useSubscription();
  const t = useCopy().account.billing.trialExpired;
  const [open, setOpen] = useState(false);
  const [showPricing, setShowPricing] = useState(false);

  // Mostrar modal quando trial expirou e não foi dismissado nesta sessão
  useEffect(() => {
    const isExpired = isTrialExpired || (isFree && subscription?.status === 'trialing');
    if (!isExpired) return;

    const dismissed = sessionStorage.getItem(DISMISSED_KEY);
    if (!dismissed) {
      setOpen(true);
    }
  }, [isTrialExpired, isFree, subscription?.status]);

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    setOpen(false);
  };

  const handleUpgrade = () => {
    sessionStorage.setItem(DISMISSED_KEY, 'true');
    setOpen(false);
    setShowPricing(true);
  };

  return (
    <>
      <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) handleDismiss(); }}>
        <DialogContent className="max-w-md text-center">
          <div className="w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center mx-auto mb-4">
            <Clock size={32} className="text-amber-600" />
          </div>

          <DialogHeader className="text-center">
            <DialogTitle className="text-xl">{t.title}</DialogTitle>
            <DialogDescription className="text-sm leading-relaxed mt-2">
              {t.bodyPre}<strong>{t.bodyStrong}</strong>{t.bodyPost}
            </DialogDescription>
          </DialogHeader>

          <div className="flex flex-col gap-2 mt-6">
            <Button variant="primary" size="lg" onClick={handleUpgrade} className="w-full">
              <ArrowUpRight size={18} />
              {t.cta}
            </Button>
            <Button variant="ghost" onClick={handleDismiss} className="w-full text-[var(--color-text-secondary)]">
              {t.dismiss}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {showPricing && <PricingPage onClose={() => setShowPricing(false)} />}
    </>
  );
}
